import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, List, Modal } from 'antd';
import { TRIP_TASK_TYPE_MAP } from 'components/trips/trip-tasks/components/trip-task-item/constants';
import type { ITripTaskMergeModalProps } from './types';

export const TripTaskMergeModal: React.FC<ITripTaskMergeModalProps> = (props) => {
  const { open, tasks, isPending, onCancel, onSubmit } = props;
  const { t } = useTranslation('trip');
  const [selectedTaskIds, setSelectedTaskIds] = useState<number[]>([]);

  const handleOpenChange = (isOpen: boolean) => {
    if (isOpen) {
      setSelectedTaskIds(tasks.map((task) => task.id));
    }
  };

  const handleSubmit = () => onSubmit(selectedTaskIds);

  return (
    <Modal
      open={open}
      title={t('merge_tasks_modal_title')}
      okText={t('merge_tasks')}
      okButtonProps={{ disabled: selectedTaskIds.length < 2 }}
      confirmLoading={isPending}
      afterOpenChange={handleOpenChange}
      onCancel={onCancel}
      onOk={handleSubmit}>
      <Checkbox.Group value={selectedTaskIds} onChange={(values) => setSelectedTaskIds(values)}>
        <List
          dataSource={tasks}
          renderItem={(task) => (
            <List.Item>
              <Checkbox value={task.id}>
                #{task.sequence} {TRIP_TASK_TYPE_MAP[task.type]} - {task.warehouse?.name}
              </Checkbox>
            </List.Item>
          )}
        />
      </Checkbox.Group>
    </Modal>
  );
};
